firebird.directive('profileDropdownTrigger', [
    '$rootScope',
    function ($rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (element.is('body')) {
                    //If body, register click event to close any open profile cards
                    element.bind('click', function (e) {
                        $rootScope.$broadcast('close-profile-dropdown');
                    });
                } else {
                    //Otherwise, attendee in the attendee list was clicked...
                    //Stop propagation to prevent body from receiving click event
                    element.bind('click', function (e) {
                        e.stopPropagation();
                    });
                }
            }
        };
    }
]);
